<template lang="pug">
span( :class="getColor(getValue)") {{ getText }}
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator'
import { Component } from 'vue-property-decorator'

@Component({
  name: 'columnTagsStatusTemplate'
})
export default class TagsStatusTemplateComponent extends Vue {
  data: any

  get getTags() {
    return this.data.column.tags || null
  }

  get getValue() {
    const { field } = this.data.column
    return this.data[field]
  }

  get getText() {
    const value = this.getValue
    return this.getTranslateTexts(value)
  }

  getTranslateTexts (value: string | boolean | null | undefined | false) {
    if (value === '' || value === null || value === undefined || value === false) {
      return ''
    }

    if (value === true) {
      return this.$t('action_buttons.yes')
    }

    return this.$t(`grid.columns.tags.${ value.toLowerCase() }`)
  }

  getColor(value: string): string {
    const tags = this.getTags
    if(!tags || value === undefined) {
      return ''
    }
    return `${tags[value]} status`
  }
}
</script>
